import { Type } from '@sinclair/typebox';

import { Nullable } from './generics';

// Recipes
export const Recipe = Type.Object({
  id: Type.String(),
  slug: Type.String(),
  title: Type.String(),
  thumbnail: Type.String(),
  video: Nullable(Type.String()),
  short_desc: Type.String(),
  category: Type.Union([Type.Literal('food'), Type.Literal('beverage')]),
  views: Type.Integer(),
  body: Type.Union([
    Type.Record(Type.String(), Type.Unknown()),
    Type.Array(Type.Record(Type.String(), Type.Unknown())),
  ]),
  making_duration: Type.Integer(),
  portion_size: Type.Integer(),
  author: Type.String(),
  is_published: Type.Boolean(),
  allergens: Type.Array(Type.String()),
  index: Type.Integer(),
  created_at: Type.Integer({ minimum: 0 }),
  created_by: Type.Optional(Type.String({ format: 'uuid' })),
  updated_at: Type.Integer({ minimum: 0 }),
  updated_by: Type.Optional(Type.String({ format: 'uuid' })),
  deleted_at: Type.Integer({ minimum: 0 }),
  deleted_by: Type.Optional(Type.String({ format: 'uuid' })),
});

// Recipe Tags
export const RecipeTag = Type.Object({
  id: Type.String(),
  name: Type.String(),
  big_icon_url: Type.String(),
  small_icon_url: Type.String(),
  text_color: Type.String(),
  bg_color: Type.String(),
  created_at: Type.Integer({ minimum: 0 }),
  created_by: Type.Optional(Type.String({ format: 'uuid' })),
  updated_at: Type.Integer({ minimum: 0 }),
  updated_by: Type.Optional(Type.String({ format: 'uuid' })),
  deleted_at: Type.Integer({ minimum: 0 }),
  deleted_by: Type.Optional(Type.String({ format: 'uuid' })),
});

// Recipe Taggings
export const RecipeTagging = Type.Object({
  recipe_id: Type.String(),
  tag_id: Type.String(),
});

// Recipe Ingredient Groups
export const RecipeIngredientGroup = Type.Object({
  id: Type.String(),
  recipe_id: Type.String(),
  index: Type.Integer(),
  title: Type.String(),
  is_optional: Type.Boolean(),
});

// Recipe Ingredients
export const RecipeIngredient = Type.Object({
  group_id: Type.String(),
  id: Type.String(),
  index: Type.Integer(),
  title: Type.String(),
  amount: Type.Integer(),
  amount_unit: Type.String(),
});

// Recipe Products
export const RecipeProduct = Type.Object({
  recipe_id: Type.String(), // shortcut to quickly retrive product referral to recipe
  recipe_ingredient_id: Type.String(),
  product_id: Type.String(),
  recipe_type: Type.Union([
    Type.Literal('recommended'),
    Type.Literal('alternative'),
  ]),
  product_type: Type.Union([
    Type.Literal('primary'),
    Type.Literal('secondary'),
  ]),
});

// Recipe Medias
export const RecipeMedia = Type.Object({
  id: Type.String(),
  recipe_id: Type.String(),
  url: Type.String(),
  type: Type.Union([Type.Literal('image'), Type.Literal('video')]),
});

// Recipe Favorites
export const RecipeFavorite = Type.Object({
  recipe_id: Type.String(),
  user_id: Type.String(),
});

// Recipe Notifications
export const RecipeNotifications = Type.Object({
  id: Type.String(),
  recipe_id: Type.String(),
  title: Type.String(),
  description: Type.String(),
  status: Type.Union([Type.Literal('pending'), Type.Literal('success')]),
  created_at: Type.Integer({ minimum: 0 }),
  created_by: Type.Optional(Type.String({ format: 'uuid' })),
  updated_at: Type.Integer({ minimum: 0 }),
  updated_by: Type.Optional(Type.String({ format: 'uuid' })),
});

// Recipe Sections
export const RecipeSection = Type.Object({
  id: Type.String(),
  title: Type.String(),
  type: Type.Union([
    Type.Literal('created_at_desc'),
    Type.Literal('views_desc'),
    Type.Literal('manual'),
  ]),
  is_for_homepage: Type.Boolean(),
  index: Type.Integer(),
  created_at: Type.Integer({ minimum: 0 }),
  created_by: Type.Optional(Type.String({ format: 'uuid' })),
  updated_at: Type.Integer({ minimum: 0 }),
  updated_by: Type.Optional(Type.String({ format: 'uuid' })),
  deleted_at: Type.Integer({ minimum: 0 }),
  deleted_by: Type.Optional(Type.String({ format: 'uuid' })),
});

// Recipe Sections
export const RecipeSectionItem = Type.Object({
  id: Type.String(),
  recipe_section_id: Type.String({ format: 'uuid' }),
  recipe_id: Type.String({ format: 'uuid' }),
  index: Type.Integer(),
  created_at: Type.Integer({ minimum: 0 }),
  created_by: Type.Optional(Type.String({ format: 'uuid' })),
  updated_at: Type.Integer({ minimum: 0 }),
  updated_by: Type.Optional(Type.String({ format: 'uuid' })),
});

// Recipe Business Type
export const RecipeBusinessType = Type.Object({
  id: Type.String(),
  recipe_id: Type.String({ format: 'uuid' }),
  cg_3_business_type: Type.String(),
  created_at: Type.Integer({ minimum: 0 }),
  updated_at: Type.Integer({ minimum: 0 }),
});
